<template>
  <div>
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
import { ref } from 'vue'
const highTemps = ref([])
const lowTemps = ref([])
var monthData = []

export default {
  props: [ 'monthlyData' ],
  setup(props) {
    const propData = ref(props.monthlyData)
    for (var i = 1; i < 13; i++) {
      monthData = propData.value[i]
      highTemps.value[i-1] = monthData.high
      lowTemps.value[i-1] = monthData.low
    }
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: "月別最高気温・最低気温",
          x: -20 //center
        },
        colors: ['#F44336', '#2196F3'],
        xAxis: {
          categories: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ],
          crosshair: true
        },
        yAxis: {
          labels: {
            format: '{value}°C'
          },
          title: {
            text: "気温"
          },
          plotLines: [
            {
              value: 0,
              width: 1,
              color: "#808080"
            }
          ],
          max: 50 // 40 for France
        },
        tooltip: {
          shared: true,
          valueSuffix: "°C"
        },
        legend: {
          align: 'left',
          x: 80,
          verticalAlign: 'top',
          y: 60,
          floating: true
        },
        series: [
          {
            name: "最高気温",
            data: highTemps
/*
            [ 8, 9, 13, 17, 20, 24 26, 25, 22, 17, 11, 8 ]
*/
          },
          {
            name: "最低気温",
            data: lowTemps
/*
            [ 3, 3, 5, 8, 11, 14, 16, 16, 13, 10, 6, 4 ]
*/
          }
        ],
        accessibility: {
          enabled: false  // To remove highcharts accessibility warning
        }
      }
    };
  },
  watch: { // It listens to the change in props monthlyData
    monthlyData: function () {
      for (var i = 1; i < 13; i++) {
        monthData = this.monthlyData[i]
        highTemps.value[i-1] = monthData.high
        lowTemps.value[i-1] = monthData.low
      }
    }
  },
};
</script>
